import * as types from "./types";
import { combineReducers } from "redux";
import _ from "lodash";

function asignacionData(state = {}, { type, payload }) {
  switch (type) {
    case types.SET_COLEGIO_ACTIVIDAD_DATA:
      return payload;
    case types.RESET_COLEGIO_ACTIVIDAD_DATA:
      return {};
    default:
      return state;
  }
}

function actividadesAsignadas(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_ASIGNADAS:
      let data = _.cloneDeep(state);
      data.push(payload);
      return data;

    case types.CHANGE_ASIGNADAS:
      let acts = _.cloneDeep(state);
      let newState = acts.map(act => (act.id !== payload.id ? act : payload));
      return newState;

    case types.RESET:
    case types.RESET_ACTIVIDADES_ASIGNADAS:
      return [];

    default:
      return state;
  }
}

function alumnosAsignados(state = [], { type, payload }) {
  switch (type) {
    case types.FETCH_ALUMNOS_ASIGNADOS:
      let data = _.cloneDeep(state);
      data.push(payload);
      return data;

    case types.CHANGE_ALUMNOS_ASIGNADOS:
      let acts = _.cloneDeep(state);
      return acts.map(act => (act.id !== payload.id ? act : payload));

    case types.REMOVE_ALUMNOS_ASIGNADOS:
      let lista = _.cloneDeep(state);
      return lista.filter(item => item.key !== payload);

    case types.RESET_ALUMNOS_ASIGNADOS:
      return [];

    default:
      return state;
  }
}

const reducer = combineReducers({
  asignacionData,
  actividadesAsignadas,
  alumnosAsignados
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/asignaciones/reducers.js